// src/i18n/en/preferences.ts
// English mirror of es/preferences.ts.
export const preferences = {
  title: 'My preferences',
  subtitle: 'How you want to see things. Saved per user.',
  tabs: {
    mine: 'My preferences',
    hotel: 'Hotel settings',
    roommatik: 'Roommatik settings',
  },
  fields: {
    language: 'Language',
    landingPage: 'Landing page',
    defaultScope: 'Default scope',
    tableDensity: 'Table density',
  },
  landingPageOptions: {
    arrivals: 'Arrivals today',
    reservations: 'Reservations',
    summary: 'Summary',
  },
  defaultScopeOptions: {
    remembered: 'Remember the last selection',
    allHotels: 'All hotels',
  },
  tableDensityOptions: {
    comfortable: 'Comfortable',
    compact: 'Compact',
  },
  saved: 'Preferences saved successfully.',
  saveError: 'Could not save your preferences to the server. Saved on this device instead.',
  loadError: 'Could not load your preferences from the server. Showing the ones saved on this device.',
};

export default preferences;
